module.exports = __webpack_public_path__ + "static/img/1.ed29543.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/10/1.png
// module id = QGN6
// module chunks = 0